import React from 'react';
import PropTypes from 'prop-types';
import Product from './Product';
import Carousel, { slickBreakpoints } from './Carousel';

export const ProductCarousel = ({ products, title, subTitle }) => {
  const responsiveSettings = maxSlides => {
    if (products.length < maxSlides) {
      return {
        slidesToShow: products.length,
        className: 'ProductCarouselStatic',
      };
    }
    return {
      slidesToShow: maxSlides,
      slidesToScroll: maxSlides,
    };
  };

  const productSliderSettings = {
    className: 'ProductCarousel',
    dots: false,
    infinite: false,
    speed: 800,
    responsive: [
      {
        breakpoint: slickBreakpoints.desktopLarge,
        settings: responsiveSettings(8),
      },
      {
        breakpoint: 2560 - 1,
        settings: responsiveSettings(7),
      },
      {
        breakpoint: 1650 - 1,
        settings: responsiveSettings(6),
      },
      {
        breakpoint: 1200 - 1,
        settings: responsiveSettings(5),
      },
    ],
  };

  return (
    <>
      <h2 className="ProductCarousel__Title">{title}</h2>
      <div className="ProductCarousel__SubTitle">{subTitle}</div>
      <Carousel options={productSliderSettings}>
        {products.map((product, i) => {
          return <Product key={i} {...product} inCarousel />;
        })}
      </Carousel>
    </>
  );
};

ProductCarousel.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object),
  subTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
